import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { LoggingMessageService } from 'src/app/services/logging-message.service';

@Component({
  standalone: true,
  selector: 'app-logged-out',
  templateUrl: './logged-out.component.html'
})

export class LoggedOutComponent implements OnInit {
  private logger: LoggingMessageService;
  public hiddenPortalSrc: SafeUrl;
  public hiddenIndicatorSrc: SafeUrl;

  constructor(private sanitizer: DomSanitizer, private log: LoggingMessageService) {
    this.logger = log;
  }

  ngOnInit() {
    this.setHiddenPortalIframeSrc();
    this.setHiddenIndicatorIframeSrc();

    setTimeout(() => {
      this.logger.debug('logged-out.component.ts', 'ngOnInit', 0, '', 'Logout component loading logout page', '');
      window.location.href = environment.LoggedOutPage;
    }, 2000);
  }

  setHiddenPortalIframeSrc() {
    const url = environment.LogoutPage;
    this.hiddenPortalSrc =  this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  setHiddenIndicatorIframeSrc() {
    const url = environment.IndicatorFactoryLogoutPage;
    this.hiddenIndicatorSrc =  this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

}
